import { getManagerListOptions } from '../../../../api'
import { sortBirdviewLoadItems } from '../../DashboardBirdview.utils'
import {
  getBirdviewOpenRequestsFilters,
  getBirdviewOverdueRequestsFilters,
} from '../../DashboardBirdview.utils.api'
import { useBirdviewRequestLoaders } from '../useBirdviewRequestLoaders'

import { BIRDVIEW_TEAM_LOAD_PARAMS } from './useBirdviewTeamLoadLoaders.constants'
import {
  getBirdviewTeamLoadTotal,
  getBirdviewTeamMemberParams,
  toBirdviewTeamLoadItems,
} from './useBirdviewTeamLoadLoaders.utils'

export function useBirdviewTeamLoadLoaders() {
  const { getRequestsCountTile } = useBirdviewRequestLoaders()

  async function getTeamMemberLoad(member) {
    const params = getBirdviewTeamMemberParams(member)

    const [{ count: open }, { count: overdue }] = await Promise.all([
      getRequestsCountTile(getBirdviewOpenRequestsFilters(params)),
      getRequestsCountTile(getBirdviewOverdueRequestsFilters(params)),
    ])

    return { ...member, open, overdue }
  }

  // The backend has no per-manager aggregate, so the load of the shown team
  // members is counted one by one.
  async function getTeamLoadSection() {
    const response = await getManagerListOptions(BIRDVIEW_TEAM_LOAD_PARAMS)

    const items = await Promise.all(
      toBirdviewTeamLoadItems(response).map(getTeamMemberLoad)
    )

    return {
      items: sortBirdviewLoadItems(items),
      total: getBirdviewTeamLoadTotal({ items, response }),
    }
  }

  return { getTeamLoadSection }
}
